import React, { useState } from 'react';
import { AxiosResponse } from 'axios';
import {
  Container,
  Card,
  CardHeader,
  CardContent,
  CardActions,
  Button,
  TextField,
  Alert,
  AlertTitle,
  InputLabel
} from '@mui/material';
import './checkNft.scss';
import { getMissingNfts } from '../../api/b2b';
import { useTranslation } from 'react-i18next';
import Loader from '../../common-components/loader';
import CustomAlert from '../../Components/CustomAlert';

const CheckNft = () => {
  const [loading, setLoading] = useState(false);
  const [email, setEmail] = useState('');
  const [response, setResponse] = useState(false);
  const [missingNfts, setMissingNfts] = useState(0);
  const [showError, setShowError] = useState(false);
  const [errorMessage, setErrorMessage] = useState('');

  const { t } = useTranslation();

  const handleSubmit = async () => {
    setLoading(true);
    try {
      const result: AxiosResponse = await getMissingNfts(email);
      if (result.data.success === true) {
        setMissingNfts(result.data.data.missingNfts);
        setResponse(true);
      }
    } catch (error: any) {
      setErrorMessage(error.response?.data?.errorMessage);
      setShowError(true);
    } finally {
      setLoading(false);
    }
  };

  return (
    <Container>
      <Loader visible={loading} fullscreen={true} />
      <Card className="cardNft">
        <CardHeader
          subheader={t('CHECK_NFT')}
          className="cardHeader"
        ></CardHeader>
        <CardContent className="cardContent">
          <InputLabel>{t('EMAIL')}</InputLabel>
          <TextField
            sx={{
              '& legend': { display: 'none' },
              '& fieldset': { top: 0 }
            }}
            size="small"
            id="email"
            type="email"
            fullWidth
            value={email}
            onChange={(e) => setEmail(e.target.value)}
          />
          {response && (
            <Alert className="alert" severity="info" sx={{ width: '100%' }}>
              <AlertTitle>Info</AlertTitle>
              {`${t('HOW_MANY_NFT_ARE_NOT_CREATED')}${missingNfts}`}
            </Alert>
          )}
        </CardContent>
        <CardActions>
          <Button
            className="button"
            variant="contained"
            disabled={!email ? true : false}
            onClick={handleSubmit}
          >
            {t('CHECK')}
          </Button>
        </CardActions>
      </Card>
      <CustomAlert
          show={showError}
          message={errorMessage}
          onClose={() => { setShowError(false); setErrorMessage(''); }}
        />
    </Container>
  );
};

export default CheckNft;
